import React from 'react';
import { useLoaderData, useParams } from '@tanstack/react-router';
import { SurveyModel } from 'survey-core';
import Survey from '../survey/survey';
import { getSurveyModel } from '../survey-questions/get-survey-model';
import { TradeReferenceLoaderResponse } from '../../routes/trade-references/$accountSlug/$trackingId/index';
import { isApiError } from '../../utils/errors';
import { useStatusMessageDispatch } from '../../hooks/StatusMessageContext';
import ErrorPage from '../status-pages/error-page';
import { postTradeReference } from '../../api/trade-references/post-trade-reference';
import i18n from '../../i18n';

const TradeReference: React.FC = () => {
  const loaderData = useLoaderData({ from: '/trade-references/$accountSlug/$trackingId/' }) as TradeReferenceLoaderResponse;

  const { setStatusMessage } = useStatusMessageDispatch();
  const { trackingId } = useParams({ from: '/trade-references/$accountSlug/$trackingId/' });

  if (loaderData.type === 'error') {
    return <ErrorPage
      errorType={loaderData.error}
           />;
  }

  // TypeScript now knows this is the success case, so settings is guaranteed to exist
  const { settings } = loaderData;

  const handleSubmission = async (sender: SurveyModel) => {
    try {
      await postTradeReference(settings.urlSlug, trackingId, sender.data);

      setStatusMessage({
        severity: 'success',
        message: 'Trade reference submitted successfully',
      });
    } catch (err) {
      setStatusMessage({
        severity: 'error',
        message: isApiError(err) ? err.message : 'Failed to submit trade reference',
      });
    }
  };

  const surveyModel = getSurveyModel({
    settings,
    onComplete: handleSubmission,
    completedHtml: i18n.t('components:pages.trade_reference_submitted'),
    trackingId,
  });

  return (
    <Survey
      surveyModel={surveyModel}
    />
  );
};

export default TradeReference;
